module.exports = __webpack_public_path__ + "media/images/loader-blocks-05598322.gif";